import React from 'react';

import PageContentWrapperComponent from 'components/global-components/page-content-wrapper-component/PageContentWrapperComponent';
import ProductGridListComponent from 'components/global-components/product-grid-component/ProductGridListComponent';
import { useFilteredProducts } from 'hooks/useFilteredProducts';
import { useOpportunity } from 'hooks/useOpportunity';
import { useSelectedAccount } from 'hooks/useSelectedAccount';
import { getPackageText } from 'toolboxes/reuseable-logic/state-specific-language/package-language-change';

const CasketPageComponent: React.FunctionComponent = () => {
    const products = useFilteredProducts(null, 'Casket');
    const { selectedAccount } = useSelectedAccount();
    const { opportunity } = useOpportunity();

    const packageText = getPackageText(selectedAccount);

    return (
        <PageContentWrapperComponent
            title="Select a Casket"
            subtitle={
                <>
                    Below you will find all of the casket options we have for you to choose from. Based on the{' '}
                    {opportunity.disposition.toLowerCase()} {packageText.toLowerCase()} you selected, a casket may have
                    been pre-selected for you, but you can replace it with the option of your choice. Once you’ve made
                    your selection, click "Continue."
                </>
            }
        >
            <ProductGridListComponent products={products} productSubcategory="Casket" />
        </PageContentWrapperComponent>
    );
};

export default CasketPageComponent;
